import type { ReactNode, SVGProps } from 'react';

/** Line icons from the Direction C prototype. Decorative unless given a title by the caller. */
type IconProps = Omit<SVGProps<SVGSVGElement>, 'children' | 'stroke'> & {
  size?: number;
  weight?: number;
};

function Svg({ size = 17, weight = 1.8, children, ...rest }: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={weight}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export function PlusIcon(p: IconProps) {
  return (
    <Svg weight={2.2} {...p}>
      <path d="M12 5v14M5 12h14" />
    </Svg>
  );
}
export function HomeIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M3 10.5 12 3l9 7.5V21h-6v-6H9v6H3z" />
    </Svg>
  );
}
export function FlagIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M5 21V4h11l-2 4 2 4H5" />
    </Svg>
  );
}
export function PeopleIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.8-3.6 3.3-5.5 6.5-5.5s5.7 1.9 6.5 5.5M16 4.8a3.5 3.5 0 0 1 0 6.4M18.5 14.8c1.6.8 2.6 2.5 3 5.2" />
    </Svg>
  );
}
export function ChartIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M4 20V11M10 20V5M16 20v-6M2 20h20" />
    </Svg>
  );
}
export function LockIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="5" y="11" width="14" height="10" rx="1.5" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </Svg>
  );
}
export function CopyIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="8" y="8" width="12" height="12" rx="1.5" />
      <path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" />
    </Svg>
  );
}
export function UploadIcon(p: IconProps) {
  return (
    <Svg weight={2} {...p}>
      <path d="M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" />
    </Svg>
  );
}
export function PhoneIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <rect x="7" y="2.5" width="10" height="19" rx="2" />
      <path d="M11 18.5h2" />
    </Svg>
  );
}
export function PaperclipIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <path d="M20 11.5 12.5 19a5 5 0 0 1-7-7l8-8a3.3 3.3 0 0 1 4.7 4.7l-8 8a1.7 1.7 0 0 1-2.4-2.4L15 7" />
    </Svg>
  );
}
export function SearchIcon(p: IconProps) {
  return (
    <Svg {...p}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m20 20-4.2-4.2" />
    </Svg>
  );
}
export function ExpandIcon(p: IconProps) {
  return (
    <Svg weight={2} {...p}>
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </Svg>
  );
}
export function FileIcon(p: IconProps) {
  return (
    <Svg weight={2} {...p}>
      <path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z" />
      <path d="M14 3v5h5" />
    </Svg>
  );
}
export function CheckIcon(p: IconProps) {
  return (
    <Svg weight={2.4} {...p}>
      <path d="m5 12.5 4.5 4.5L19 7.5" />
    </Svg>
  );
}
